import React from "react";
import { Layout } from "Components/Layout/Layout";
import { lazyLoader } from "Service/loader";

const WarrantyEdit = lazyLoader(
  () => import("Containers/Warranty/WarrantyForm/WarrantyForm")
);

export const WarrantyEditForm = () => {
  return (
    <Layout>
      <WarrantyEdit type="EDIT" />
    </Layout>
  );
};
